import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  nestedProduct: {
    '&:hover': {
      background: 'rgba(248,137,173,0.57)',
      cursor: 'pointer',
    },
  },

  tableContainer: {
    '& tr': {
      borderBottom: `1px solid ${theme.palette.border.main}`,

      '& th, & td': {
        borderBottom: 'none',
      },
    },
  },

  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  table: {
    borderCollapse: 'collapse',
  },

}));

export default useStyles;
